/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable no-unused-vars */
import 'moment-timezone';
import React, { useContext, useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { CommonDateTime } from "../../Api/commonDateTime";
import wsSend_request from "../../Api/ws/ws_request";
import { WebSocketContext } from "../../App";
import ReusableTable from "../UserInformation/ReusableTable";

const ReportTransactionList = () => {
  const { websocket } = useContext(WebSocketContext);
  const { search, userId, reportMessageList, reportList ,userList} = useSelector((state) => state.adminReducers);
  const [currentPage, setCurrentPage] = useState(1);
  const [comment, setComment] = useState(""); // Single comment state
  const [currentReportId, setCurrentReportId] = useState(null); // Track the report currently being edited

  const UserDetail = (id) => {
  const userInf = userList?.list?.filter((user) => user?.id === id)[0]
  return {
    userName: userInf?.username,
    useEmail: userInf?.email,
    mobileNUmber: userInf?.phone,
    user_code:userInf?.user_code
  }
}
 useEffect(() => {  
    let param = {
        "transmit": "single",
        "url": "user_list",
        "request": {
          "status": true,
          "limit": "10000000",
          "page_no": 1,
          "search": "",
          "order_by": "-updated_at"
        }
      }
      wsSend_request(websocket, param)}, []);


  const currentFunction = (page) => {
    setCurrentPage(page);
  };

  const reportDetail = (id) => {
    const report = reportList?.list?.filter((report) => report?.id === id)[0];
    return {
      title: report?.title,
    }
  }

  const updateDetail = (id, report_id) => {
    if (report_id && id) {
      let param = {
        "transmit": "single",
        "url": "report_message_edit",
        "request": {
          "report_msg_id": id,
          "comment": comment, // Use the single comment state
          "report_id": report_id
        }
      };
      wsSend_request(websocket, param);
    }
  }

  useEffect(() => {
    let param = {
      "transmit": "single",
      "url": "report_message_list",
      "request": {
        "limit": "20",
        "page_no": currentPage,
      }
    };
    wsSend_request(websocket, param);
  }, [websocket, currentPage, search, userId]);

  useEffect(() => {
    let param = {
      "transmit": "single",
      "url": "report_list",
      "request": {
        "limit": "20",
        "page_no": currentPage,
      }
    };
    wsSend_request(websocket, param);
  }, [websocket, currentPage, search, userId]);

  
const headers = [
  { name: "Date & Time", key: "dateTime" },
  { name: "User Name", key: "userName" },
  { name: "Mobile Number", key: "mobileNumber" },
  { name: "Topic", key: "topic" },
  { name: "Message", key: "message" },
  { name: "Comment", key: "comment" }
];

          const renderRow = (report, index,visibleColumns) => {    
              return(
            <React.Fragment key={report?.id}>
              <tr key={report?.id} className="user-management-table-detail">
                   {visibleColumns?.includes('dateTime') &&<td style={{ cursor: "default" }} className="Vertical_align">
                      {CommonDateTime(report.created_at, "DD MMM YYYY", "show")}
                      <span className="ms-2">{CommonDateTime(report.created_at, "hh:mm A", "show")}</span>
                    </td>} 
                    {visibleColumns?.includes('userName') &&<td style={{ cursor: "default" }} className="Vertical_align">{UserDetail(report?.user_id)?.userName || "-"}</td>}
                    {visibleColumns?.includes('mobileNumber')&&<td style={{ cursor: "default" }} className="Vertical_align">{UserDetail(report?.user_id)?.mobileNUmber || "-"}</td>}
                    {visibleColumns?.includes('topic')&&<td style={{ cursor: "default" }} className="Vertical_align">{reportDetail(report?.report_id)?.title}</td>}
                    {visibleColumns?.includes('message')&&<td style={{ cursor: "default" }} className="Vertical_align">{report.message || "-"}</td>}
                    {visibleColumns?.includes('comment')&&
                    <td  className="Vertical_align">
                    <div className="d-flex align-items-center gap-4">
                      <div >
                        <textarea
                        className="answer_div"
                          onChange={(e) => setComment(e.target.value)} 
                          value={currentReportId === report.id ? comment : report.comment || ""} 
                          onFocus={() => {
                            setComment(report.comment || ""); // Set comment to existing value when focusing
                            setCurrentReportId(report.id); // Set the current report being edited
                          }}
                        ></textarea>
                      </div>
                      <span >
                        <button
                          id="button"
                          className="pt-1 ps-2 pe-2 pb-1"
                          style={{ fontSize: "13px", marginLeft: "2px" }}
                          onClick={() => updateDetail(report?.id, report?.report_id)} // Call updateDetail on button click
                        >
                          Save
                        </button>
                      </span>

                    </div>
                      </td>
                    }
                  </tr>
            </React.Fragment>
          );
      
          }
  return (
    <>
        <ReusableTable
                headers={headers}
                data={reportMessageList?.list || []}
                paginationObject={reportMessageList?.pagination}
                renderRow={renderRow}
                filters={{
                  fromDate: false,
                  toDate: false,
                  period: false,
                  search: false,
                  searchPlaceholder: "Search by",
                  userSelect: false,
                  userOptions:[],
                  export: false,
                      reset:false,

                }}
                currentPage={currentPage}
                handlePageChange={currentFunction}
               />
    </>
  );
};

export default ReportTransactionList;
